package com.essntl.features.travelagent.data.supabase

import com.essntl.features.contact.data.supabase.ContactDto
import com.essntl.features.file.domain.model.FileModel
import com.essntl.features.travelagent.domain.model.TravelAgentModel
import io.github.jan.supabase.postgrest.query.Columns
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class TravelAgentDto(
    val id: String,
    @SerialName("job_title")
    val jobTitle: String? = null,
    val source: String? = null,
    @SerialName("created_at")
    val createdAt: String,
    @SerialName("commission_type")
    val commissionType: String? = null,
    val commission: Double?,
    @SerialName("qb_customer_id")
    val qbCustomerId: String? = null,
    @SerialName("contact_id_data")
    val contact: ContactDto?,
) {
    fun toModel() =
        TravelAgentModel(
            id = id,
            jobTitle = jobTitle,
            source = source,
            createdAt = createdAt,
            commission = commission,
            qbCustomerId = qbCustomerId,
            contact = contact?.toModel(),
            commissionType =
                when (commissionType) {
                    "NET" -> TravelAgentModel.CommissionType.Net
                    "GROSS" -> TravelAgentModel.CommissionType.Gross
                    else -> TravelAgentModel.CommissionType.Gross
                },
        )

    companion object {
        const val COLUMNS_VALUE = "*, contact_id_data:contact_id(${ContactDto.COLUMNS_VALUE})"
        fun getColumns() = Columns.raw(COLUMNS_VALUE)
    }
}

internal fun TravelAgentModel.CommissionType.toDto() =
    when (this) {
        TravelAgentModel.CommissionType.Net -> "NET"
        TravelAgentModel.CommissionType.Gross -> "GROSS"
    }